import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";
import { GET_TEACHER_DETAILS, GET_STUDENT_SESSIONS, GET_TEACHER_DETAILS_FAILED, GET_STUDENT_SESSIONS_SUCCESS, GET_STUDENT_SESSIONS_FAILED, GET_TEACHER_DETAILS_SUCCESS, SET_DASHBOARD_FILTERS, GET_STUDENT_PRACTICE_SESSIONS, GET_STUDENT_CHALLENGE_SESSIONS, GET_RECENT_ASSIGNMENT_SUCCESS, GET_RECENT_ASSIGNMENT_FAILED, GET_CLASS_ASSIGNMENT_SESSION, GET_CLASS_ASSIGNMENT_SESSION_SUCCESS, GET_CLASS_ASSIGNMENT_SESSION_FAILED , GET_STUDENT_CHAPTER_PROGRESS, GET_LEADERBOARD, GET_LEADERBOARD_FAILED, GET_LEADERBOARD_SUCCESS, GET_CLASS_PROGRESS, GET_CLASS_PROGRESS_FAILED, GET_CLASS_PROGRESS_SUCCESS} from '../../constants/ActionTypes';
import TeachersOperations from "./../../aws/gql/TeachersOperations"
import { identify } from "../../analytics";

function* fetchTeacherDetails() {
  try {
    const teacherDetails = yield call(TeachersOperations.GetTeacher)
    yield put({ type: GET_TEACHER_DETAILS_SUCCESS, payload: teacherDetails })
    // if (teacherDetails){
    //   yield call(fetchStudentSessions)
    // }
    const authUser = yield select((state) => state.auth.authUser)
    identify(authUser,teacherDetails)
  } catch (error) {
    yield put({ type: GET_TEACHER_DETAILS_FAILED, payload: error.message })
  }
}

function* fetchStudentSessions() {
  const teacher_details = yield select((state) => state.dashboard.teacher_details)
  if (!teacher_details) return
  const dashboard_filters = yield select((state) => state.dashboard.dashboard_filters)
  const { schoolId = "ChIJ0XmoL2IYrjsRKIGaMnfrxQ0" } = teacher_details
  const { board = "CBSE", level = 8, subject,section = 'A' } = dashboard_filters
  console.log(dashboard_filters)
  try {
    const studentSessions = yield call(TeachersOperations.GetTeacherSession, schoolId, board, level, subject,'',section)
    yield put({ type: GET_STUDENT_SESSIONS_SUCCESS, payload: studentSessions })
  } catch (error) {
    yield put({ type: GET_STUDENT_SESSIONS_FAILED, payload: error.message })
  }
  try {
    const recentAssignment = yield call(TeachersOperations.GetRecentAssignment, schoolId, board, level, subject,'',section)
    yield put({ type: GET_RECENT_ASSIGNMENT_SUCCESS, payload: recentAssignment })
  } catch (error) {
    yield put({ type: GET_RECENT_ASSIGNMENT_FAILED, payload: error.message })
  }
}

function* fetchClassSession() {
  const class_session_id = yield select((state) => state.dashboard.class_session_id)
  try {
    const class_session = yield call(TeachersOperations.GetClassAssignment, class_session_id)
    yield put({ type: GET_CLASS_ASSIGNMENT_SESSION_SUCCESS, payload: class_session })
  } catch (error) {
    yield put({ type: GET_CLASS_ASSIGNMENT_SESSION_FAILED, payload: error.message })
  }
}
async function updatePracticeAndChallengeSessions(student_id, dispatch) {
  try {
    const practices = await TeachersOperations.GetStudentSessions(student_id, 'practice')
    dispatch({ type: GET_STUDENT_PRACTICE_SESSIONS, payload: practices })
  } catch (error) {
    console.log(error)
  }
  try {
    const challenges = await TeachersOperations.GetStudentSessions(student_id, 'challenge')
    dispatch({ type: GET_STUDENT_CHALLENGE_SESSIONS, payload: challenges })
  } catch (error) {
    console.log(error)
  }
}
async function updateStudentChapterProgress(student_id, dispatch) {
  try {
    const chapters = await TeachersOperations.GetStudentChapterProgress(student_id)
    dispatch({ type: GET_STUDENT_CHAPTER_PROGRESS , payload: chapters })
  } catch (error) {
    console.log(error)
  }
}

function* getSchoolLeaderboard(){
  try{
    const teacher_details = yield select((state) => state.dashboard.teacher_details)
    if (!teacher_details) return
    const dashboard_filters = yield select((state) => state.dashboard.dashboard_filters)
    const { board = "CBSE", level = 8, section = 'A' } = dashboard_filters
    const leaderboard = yield call(TeachersOperations.GetClassLeaderBoard,board,level,section)
    console.log("leaderboard "+JSON.stringify(leaderboard))
    yield put({type:GET_LEADERBOARD_SUCCESS,payload:leaderboard})
  }catch(error){
    yield put({type:GET_LEADERBOARD_FAILED,payload:error})
  }
}

function* getClassProgressDetails(){
  try{
    const teacher_details = yield select((state) => state.dashboard.teacher_details)
    if (!teacher_details) return
    const dashboard_filters = yield select((state) => state.dashboard.dashboard_filters)
    const { board = "CBSE", level = 8, section = 'A' } = dashboard_filters
    const class_progress = yield call(TeachersOperations.GetClassProgress,board,level,section)
    console.log("leaderboard "+JSON.stringify(class_progress))
    yield put({type:GET_CLASS_PROGRESS_SUCCESS,payload:class_progress})
  }catch(error){
    yield put({type:GET_CLASS_PROGRESS_FAILED,payload:error})
  }
}
export function* getStudentSessions() {
  yield takeEvery(GET_STUDENT_SESSIONS, fetchStudentSessions);
}

export function* getClassSession() {
  yield takeEvery(GET_CLASS_ASSIGNMENT_SESSION, fetchClassSession);
}
export function* getTeacherDetails() {
  yield takeEvery(GET_TEACHER_DETAILS, fetchTeacherDetails);
}
// export function* updateDashboardFilter() {
//   yield takeEvery(SET_DASHBOARD_FILTERS, fetchStudentSessions);
// }
export function* getLeaderboard() {
  yield takeEvery(GET_LEADERBOARD, getSchoolLeaderboard);
}
export function* getClassProgress() {
  yield takeEvery(GET_CLASS_PROGRESS , getClassProgressDetails);
}
export function getStudentPracticeSessions(student_id, dispatch) {
  updatePracticeAndChallengeSessions(student_id, dispatch);
}
export function getStudentChapterProgress(student_id, dispatch) {
  updateStudentChapterProgress(student_id, dispatch);
}

export default function* rootSaga() {
  yield all([fork(getStudentSessions),
  fork(getTeacherDetails),
  // fork(updateDashboardFilter),
  fork(getClassSession),
  fork(getLeaderboard),
  fork(getClassProgress)]);
}
